import { Grid, TextField } from "@mui/material";
import { doc, setDoc } from "firebase/firestore";
import React from "react";
import { docData } from "rxfire/firestore";

import CustomizedSnackbars from "../alert";
import { db } from "../../config/firebaseinit";

export default function SetFee() {
  const [fee, setFee] = React.useState(300);

  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  React.useEffect(() => {
    const subscribe = () => {
      const querydoc = doc(db, `fee/fee`);
      return docData(querydoc).subscribe((data) => {
        console.log(data);
        setFee(data.amount);
      });
    };

    subscribe();
    return subscribe().unsubscribe();
  }, [setFee]);

  const updateFee = (event) => {
    // setFee(event.target.value);
    //console.log(event.target.value);
    const querydoc = doc(db, `fee/fee`);
    setDoc(querydoc, { amount: parseInt(event.target.value) }, { merge: true }).then(
      () => {
        setOpenSnackbar(true);
      }
    );
  };

  return (
    <>
      <CustomizedSnackbars
        openSnackbar={openSnackbar}
        handleCloseSnackbar={handleCloseSnackbar}
        severity="success"
        message={`fee updated successfully`}
      />
      <TextField
        type="number"
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="outlined-controlled"
        label={"Fee"}
        value={fee}
        onBlur={updateFee}
        onChange={(event) => setFee(event.target.value)}
        name="fee"
      />
    </>
  );
}
